/**
 * @module app.shared
 */

import { autoinject, bindable } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';

@autoinject
export class EssRowClassCustomAttribute {

    @bindable({ primaryProperty: true, changeHandler: 'classNameChanged' })
    public className: string = '';

    private rowElement: HTMLElement | null = null;

    constructor(protected readonly element: Element,
        protected readonly i18n: I18N
    ) { }

    protected attached(): void {
        this.rowElement = this.element.closest('tr');
        this.addClasses(this.className);
    }

    protected detached(): void {
        this.removeClasses(this.className);
        this.rowElement = null;
    }

    protected classNameChanged(newValue: string, oldValue: string) {
        if(newValue !== oldValue) {
            this.removeClasses(oldValue);
            this.addClasses(newValue);
        }
    }

    private addClasses(classes: string): void {
        if(this.rowElement && classes && classes.length > 0) {
            for(var cssClass of classes.split(' ')) {
                if(cssClass.length > 0) {
                    this.rowElement.classList.add(cssClass);
                    if(cssClass === 'ess-row-inactive') {
                        this.rowElement.setAttribute("aria-description", this.i18n.tr('ui:table.row.inactive'));
                    }
                }
            }
        }
    }

    private removeClasses(classes: string): void {
        if(this.rowElement && classes && classes.length > 0) {
            for(var cssClass of classes.split(' ')) {
                if(cssClass.length > 0) {
                    this.rowElement.classList.remove(cssClass);
                }
            }
        }
    }

}
